// Copy of the "Employees" walkthrough. The rules every text follows are in ../../de/help.js.
export default {
  title: "Employees",
  // Short names of the views, for the header, the timeline and "Continue to …".
  section: {
    EmployeeOverview: "Overview",
    EmployeeDetail: "Employee",
    SettingsOverview: "Settings",
    UserPositionOverview: "Employee positions",
    TimeTrackingReview: "Time tracking",
  },
  // The views outside the employee list that set it up, and the ones that read a person's record
  // again. Set apart on the timeline.
  related: "Connections",
  step: {
    list: {
      text: "Every employee is listed here with their position and phone. The icon before the email says whether the person can sign in.",
    },
    create: {
      text: "This button creates new employees. First you choose whether the person becomes a login user.",
    },
    row: { text: "A click on a row opens that person with all of their data." },
    head: { text: "The person's name and photo are at the top." },
    type: {
      text: "This note says whether the person is a login user who can sign in. Management users never sign in.",
    },
    actions: {
      text: "Actions deletes the person, resets their password or turns them into a login user.",
    },
    "action-times": {
      text: "Review times opens the time tracking review with this person. Their days are approved there.",
    },
    "action-planning": {
      text: "Show in personnel planning opens the calendar this person is planned in. With several calendars you pick one.",
    },
    tabs: {
      text: "Everything about this person sits in tabs. General holds name, date of birth, phone and address.",
    },
    "company-position": {
      text: "The position decides which hourly rate this person's hours are costed with in the project costs.",
    },
    "company-wage": {
      text: "Wage type and wage record how this person is paid. The project costs are counted with the position's rate.",
    },
    "company-worktime": {
      text: "The working-time model belongs to time tracking. Its own walkthrough says what it means for target and balance.",
    },
    "company-contribution": {
      text: "The employer's contribution is a surcharge on this person's labour cost. Empty means the default from the settings applies.",
    },
    "company-holidays": {
      text: "Holiday entitlement and the social-insurance details belong to the personnel file.",
    },
    "system-email": {
      text: "A login user signs in with this address. Their credentials are sent to it as well.",
    },
    "system-roles": {
      text: "The assigned roles decide what this person may see and change. A click moves a role across and back.",
    },
    files: {
      text: "The Files tab holds documents about the person, a contract or certificates. You can upload files here.",
    },
    extended: {
      text: "Custom fields exist for every employee. Here you create one and fill it in for this person.",
    },
    activity: {
      text: "The log shows who changed what, and when. Under References you see where this person is used.",
    },
    save: { text: "Save applies the changes from every tab at once." },
    again: { text: "This button is on every page that has an explanation. One click starts it again." },
    rights: {
      text: "This is where the roles come from that you assign on a person's System specific tab. A role is a list of rights.",
    },
    contribution: {
      text: "This employer's contribution applies to every employee. On one employee you override it on the Company relevant tab.",
    },
    positions: {
      text: "Every position carries an hourly rate. It is what an hour costs, and what a project proposes when it takes the position on.",
    },
    times: {
      text: "What a person records is collected under Employees in time tracking. They are measured against the model from their Company relevant tab.",
    },
  },
}
